export enum kompetenceOverviewTypeEnum {
    DefaultView = 1,
    WideView = 2,
}
